import React from 'react';
import {
  RadiosContainer,
  ChangeSelectedWrapper,
  CheckBoxText,
  ChangeSponsorOptions,
  CheckBoxWrapper,
  CheckBoxContainer,
  TeamsContainer,
  UnselectedText,
} from './styles';
import { PowerDropdown, PowerInput, InputCheckbox, Radio, NavbarButton } from '..';
import { defaultSponsor } from '../../utils/constants/defaultSponsor';

export default ({
  selected,
  team,
  ChangeTeam,
  teamMemo,
  HandleRadiosSponsor,
  sponsor,
  handleDeleteSelected,
  ChangeSponsor,
  type,
  handleCancelBadge,
  selectAll,
  membershipsYearlyCount,
  memberships3DayCount,
}: {
  selected: Array<any>;
  team: any;
  ChangeTeam: any;
  teamMemo: Array<any>;
  HandleRadiosSponsor?: any;
  sponsor: any;
  handleDeleteSelected: any;
  ChangeSponsor?: any;
  type: String;
  handleCancelBadge?: any;
  selectAll?: any;
  membershipsYearlyCount?: any;
  memberships3DayCount?: any;
}) => {
  return (
    <>
      <ChangeSelectedWrapper>
        <CheckBoxWrapper>
          <CheckBoxContainer>
            <InputCheckbox icon={'line'} checked={selected.length > 0} onClick={selectAll} />
            <CheckBoxText>{'(' + selected.length + ')'}</CheckBoxText>
          </CheckBoxContainer>
        </CheckBoxWrapper>
        {selected.length > 0 ? (
          <>
            <TeamsContainer>
              <PowerInput
                search={true}
                onClick={ChangeTeam}
                dataArray={Boolean(team.length) ? teamMemo.filter(el => el.badge !== 'ALL') : teamMemo}
                selectedTeams={team}
                handleCancel={handleCancelBadge}
                maxWidth="470px"
                mWidth="200px"
              />
            </TeamsContainer>
            {type === 'player' ? (
              <ChangeSponsorOptions>
                <PowerDropdown
                  mHeigth="200px"
                  mWidth="200px"
                  onClick={ChangeSponsor}
                  search={false}
                  dataArray={defaultSponsor}
                  primaryTitle={sponsor.name}
                  mPadding="4px 0 4px 10px"
                  theme={'gray'}
                  membershipCount={{ trial: memberships3DayCount, yearly: membershipsYearlyCount, selected: selected.length }}
                />
              </ChangeSponsorOptions>
            ) : (
              <>
                <RadiosContainer onChange={HandleRadiosSponsor}>
                  <Radio title="Admin" name="formInfo" id={`player`} checked={sponsor.one} dynamicActive={sponsor.one} />
                  <Radio title="Coach" name="formInfo" id={`sponsored`} checked={sponsor.true} dynamicActive={sponsor.two} />
                </RadiosContainer>
              </>
            )}

            <NavbarButton title="X" icon="trash" onClick={() => handleDeleteSelected()} />
          </>
        ) : (
          <>
            <UnselectedText>
              {type === 'player' && 'Select multiple players to edit them at the same time'}
              {type === 'coach' && 'Select multiple coaches to edit them at the same time'}
            </UnselectedText>
          </>
        )}
      </ChangeSelectedWrapper>
    </>
  );
};
